/**
 * Sample images for the static (concept) parts of the v3 redesign, taken from the PM's design
 * handoff (`docs/design/v3-handoff/assets`). Static fixtures use them; dynamic screens never do.
 * The thumbnails are the design's own 58 px files (the design scales them up as well).
 */
import adBorcelleUrl from '../assets/samples/ad-borcelle.png';
import adT20Url from '../assets/samples/ad-t20.png';
import highlightUrl from '../assets/samples/highlight.png';
import stadiumPhotoUrl from '../assets/samples/stadium-photo.webp';
import t20WomenUrl from '../assets/samples/t20-women.png';
import teamBolandUrl from '../assets/samples/team-boland.png';
import teamKnightsUrl from '../assets/samples/team-knights.png';
import teamLionsUrl from '../assets/samples/team-lions.png';
import teamSaUrl from '../assets/samples/team-sa.png';
import testMatchUrl from '../assets/samples/test-match.png';

export const SAMPLE_IMAGES = {
  /** "Match Highlight" video cover. */
  highlight: highlightUrl,
  /** "T20 Womens Cricket" video cover. */
  t20Women: t20WomenUrl,
  /** "Test Match" video cover. */
  testMatch: testMatchUrl,
  /** The Wanderers photo (the design's login photo), cropped per use with `objectPosition`. */
  stadiumPhoto: stadiumPhotoUrl,
  adBorcelle: adBorcelleUrl,
  adT20: adT20Url,
  teamSouthAfrica: teamSaUrl,
  teamKnights: teamKnightsUrl,
  teamBoland: teamBolandUrl,
  /** The DP World Lions logo (the design's `logo.png`). */
  teamLions: teamLionsUrl,
} as const;

export type SampleImage = (typeof SAMPLE_IMAGES)[keyof typeof SAMPLE_IMAGES];

/** A sample image and the part of it to show (CSS `object-position`). */
export interface SamplePicture {
  src: string;
  position?: string;
}
